import { PeriodGroup } from '../periodGroup/PeriodGroup'

export enum DeliveryStatus {
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED'
}

export interface Delivery {
  id: number
  deliverySubscriptionId: number
  contractId?: number
  status?: DeliveryStatus
  meta?: DeliveryMeta
  errors?: any
  startTime?: string
  endTime?: string
  uuid: string
}

export interface DeliveryMeta {
  periodGroups?: PeriodGroup[]
}
